export default {"src":"/_next/static/media/home-highest-quality-standard-icon.e56a4fa3.svg","height":63,"width":77,"blurWidth":0,"blurHeight":0};